// @ts-check

import React, { useState } from 'react';
import store from '../../../../redux/store';
import { makeStyles } from '@material-ui/core';
import TableRow from '@material-ui/core/TableRow'
import TableCell from '@material-ui/core/TableCell'
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import TextField from '@material-ui/core/TextField';
import clsx from 'clsx';
import useFormStyles from '../../../common/FormStyle';
import { useDispatch, useSelector } from 'react-redux';
// import propTypes from 'prop-types';
import {
  SET_UNIT_TYPE,
} from '../../../../redux/actions/actionTypes'
import SimpleTextFieldd from '../../common/SimpleTextField';


/**
 * TODO: move to common and use in FlatRow as well
 */
const useEachUnitTypeStyles = makeStyles({
  unitTypeColor: {
    width: '40px',
    height: '40px',
    backgroundColor: props => props.unitType.color
  },
});

/**
 * TODO: move to common and use in FlatRow as well
 * In case of a unit deletion the index will not match, so we'll want to take the redux unitType
 */
const decideUnitTypeToRender = (unitType, updatedUnitType, index) => {
  const utFromStore = store.getState().globalFormData.buildingInfo.unit_types[index]
  if (utFromStore.id === updatedUnitType.id) {
    return updatedUnitType
  }
  return unitType
}

function CostUnitTypeRow({ unitType, index }) {
  const [updatedUnitType, setUnitType] = useState(unitType);

  const dispatch = useDispatch()
  const unitTypeStyles = useEachUnitTypeStyles({ unitType });
  const formStyles = useFormStyles();

  const unitTypeToRender = decideUnitTypeToRender(unitType, updatedUnitType, index)

  return (
    <>
      <TableRow
        key={unitType.id}
      >
        <TableCell className={[formStyles.unitsTableCell, formStyles.colorColumn].join(" ")} component="th" scope="row">
          <Box className={unitTypeStyles.unitTypeColor}></Box>
        </TableCell>
        <TableCell className={[formStyles.unitsTableCell, formStyles.unitTypeNameColumn].join(" ")} component="th" scope="row" align="right">
          <Box style={{ textAlign: "left", marginTop: "10px" }}>
            {unitTypeToRender.name}
          </Box>
        </TableCell>
        <TableCell className={[formStyles.unitsTableCell, formStyles.unitCostColumn].join(" ")} component="th" scope="row" align="right">
          <SimpleTextFieldd
            numberFormated
            variant="outlined"
            size="small"
            type="number"
            value={unitTypeToRender.cost_sqr_meter}
            onChange={(event) => {
              setUnitType({
                ...unitType,
                cost_sqr_meter: parseFloat(event.target.value)
              })
            }}
            onBlur={(event) => {
              dispatch({
                type: SET_UNIT_TYPE,
                payload: unitTypeToRender
              })
            }}
          />
        </TableCell>

        <TableCell className={[formStyles.unitsTableCell, formStyles.unitRevenueColumn].join(" ")} component="th" scope="row" align="right">
          <SimpleTextFieldd
            numberFormated
            variant="outlined"
            size="small"
            type="number"
            value={unitTypeToRender.revenue_sqr_meter}
            onChange={(event) => {
              setUnitType({
                ...unitType,
                revenue_sqr_meter: parseFloat(event.target.value)
              })
            }}
            onBlur={(event) => {
              dispatch({
                type: SET_UNIT_TYPE,
                payload: unitTypeToRender
              })
            }}
          />
        </TableCell>

      </TableRow>

    </>
  )
}


export default CostUnitTypeRow